import * as React from "react";
import { Box, Card, CardContent, Typography, Alert, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { PieChart, ChartsTooltip, PieArcLabel } from "@mui/x-charts";

export const SafePieChart = ({ data, title, height = 300 }) => {
  const theme = useTheme();

  const colorPalette = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.info.main,
    theme.palette.warning.main,
    theme.palette.success.main,
    theme.palette.error.main,
    theme.palette.primary.light,
    theme.palette.secondary.light,
    theme.palette.info.light,
  ];

  if (!data || data.length === 0) {
    return (
      <Card
        sx={{
          background: alpha(theme.palette.background.paper, 0.8),
          backdropFilter: "blur(8px)",
        }}
      >
        <CardContent>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            {title}
          </Typography>
          <Alert severity="info">No data available for this chart</Alert>
        </CardContent>
      </Card>
    );
  }

  const chartData = data.map((item, index) => ({
    id: item.status || item.type || item.name || "unknown",
    label: item.status || item.type || item.name || "unknown",
    value: parseInt(item.count || item.totalRevenue || 0),
    color: colorPalette[index % colorPalette.length],
  }));

  return (
    <Card
      sx={{
        background: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: "blur(8px)",
        height: "100%",
      }}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom fontWeight="bold" sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Box sx={{ height }}>
          <PieChart
            series={[
              {
                data: chartData,
                innerRadius: 40,
                outerRadius: 100,
                paddingAngle: 2,
                cornerRadius: 6,
                highlightScope: { faded: "global", highlighted: "item" },
                faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
                arcLabel: (item) => `${item.label} (${item.value})`,
                arcLabelMinAngle: 20,
              },
            ]}
            colors={chartData.map((item) => item.color)}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "middle" },
                padding: 0,
                labelStyle: { fontSize: 12, fill: theme.palette.text.primary },
              },
            }}
          >
            <ChartsTooltip />
            <PieArcLabel />
          </PieChart>
        </Box>
      </CardContent>
    </Card>
  );
};